import Vue from "vue";
import VueApollo from "vue-apollo";
import Tabs from "vue-tabs-component";
import Meta from "vue-meta";
import vmodal from "vue-js-modal";
import VueProgressBar from "vue-progressbar";
import VueTextareaAutosize from "vue-textarea-autosize";
import Notifications from "vue-notification";
import VueMasonry from "vue-masonry-css";
import VueCompositionApi from "@vue/composition-api";
import VueTippy, { TippyComponent } from "vue-tippy";

// Progress Bar Setup
const progressBarOptions = {
  color: "#F2AC79",
  failedColor: "#eb485f",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  position: "relative",
  inverse: false,
};

Vue.use(Meta);
Vue.use(Tabs);
Vue.use(vmodal, { dialog: true });
Vue.use(VueApollo);
Vue.use(VueProgressBar, progressBarOptions);
Vue.use(VueTextareaAutosize);
Vue.use(Notifications);
Vue.use(VueMasonry);
Vue.use(VueCompositionApi);
Vue.use(VueTippy, { arrow: true, arrowType: "round", trigger: "mouseenter" });
